<template lang="pug">
el-row(v-loading="load")
  div.center(v-if="processos.length == 0")
    span Nenhum processo vinculado.
  div.center(v-else-if="isMaranhao")
    span Para visualização dos processos vinculados do tipo REURB individual, exporte o CSV.
  div(v-else)
    div
      el-collapse(v-model="processoSelecionado")
        el-collapse-item(
          v-for="processo in processos"
          :key="processo.id"
          :title="processo.numeroProcesso"
        )
          el-card
              el-row
                el-col(:span="12")
                  strong Numero do processo:
                  span  {{ processo.numeroProcesso }}
                el-col(:span="12")
                  strong Nome do interessado:
                  span  {{ processo.nomeRazaoSocialInteressado }}
              el-row
                el-col(:span="12")
                  strong CPF/CNPJ do interessado:
                  span  {{ processo.cpfCnpjInteressado }}
                el-col(:span="12")
                  strong Setor Atual:
                  span  {{ setores[processo.setor] || ' - ' }}
              el-row
                el-col(:span="12")
                  strong Situação atual:
                  span  {{ (listaStatus && listaStatus.find(status => status.codigo ===processo.status).nome) || ' - ' }}
  div(v-if="processos.length").exportar
    el-button(@click="getCsv") Exportar CSV
</template>
<script>

import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import statusProcesso from '@/constants/statusProcessos'
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  data () {
    return {
      load: false,
      processos: [],
      processoSelecionado: null,
      listaStatus: statusProcesso,
      setores: setoresFormatado
    }
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      type: Number,
      required: true
    }
  },
  async created () {
    this.buscarProcessos()
  },

  methods: {
    ...mapActions({
      getProcessosVinculadosReurb: 'processo/getProcessosVinculadosReurb',
      getCsvIndividuaisByColetivo: 'processo/csvIndividuaisByColetivo'
    }),

    async buscarProcessos () {
      this.load = true
      try {
        this.processos = await this.getProcessosVinculadosReurb(this.idProcesso)
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
          'Houve um erro ao buscar os processos vinculados.')
      } finally {
        this.load = false
      }
    },

    async getCsv () {
      await this.getCsvIndividuaisByColetivo(this.idProcesso)
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    }
  }
}
</script>
<style>
.center {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-collapse-item__header {
  padding-left: 10px;
  color: rgb(112, 112, 112);
  font-size: 16px;
}

.exportar {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppVisualizarProcessosVinculadosTab.vue